import React from 'react'
import MainSection from '../Components/MainSection'

function TermsConditions() {
    return (
        <>
            <div className='terms_pg'>
                <MainSection title="Effective Date: October 10, 2025"
                    subtitle="Terms & Conditions"
                />
            </div>
            <section className='terms_sec'>
                <div className="contair ">
                    <h2>Welcome to Girips Technologies</h2>
                    <p>Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using our website or services.</p>
                    <div className="terms_inr">
                        <p>Welcome to Girips Technologies (“we”, “our”, “us”). These Terms and Conditions (“Terms”) govern your access to and use of our website — <a href="https://www.giripstechnologies.com" target={'_blank'} style={{ color: 'rgba(52, 152, 219, 1)' }}>www.giripstechnologies.com</a>  (“Website”) — and all software development, consulting, and digital services we provide (“Services”).
                            By accessing our Website or using our Services, you agree to be bound by these Terms. If you do not agree, please discontinue use immediately.</p>
                        <h3>1. About Girips Technologies</h3>
                        <p>Girips Technologies is a full-service IT and digital solutions company based in Jaipur, Rajasthan, India. We specialize in delivering high-quality technology solutions across multiple domains, supporting businesses with end-to-end development, consulting, and digital transformation. Each project may involve a separate contract, proposal, or scope of work (“SOW”) that outlines deliverables, pricing, and timelines.</p>
                        <h3>2. Acceptance of Terms</h3>
                        <p>By using our Website or Services, you agree to:</p>
                        <ul>
                            <li>Use the Website and Services for lawful purposes only</li>
                            <li>Provide accurate information when interacting with us</li>
                            <li>Comply with all clauses mentioned in these Terms</li>
                        </ul>
                        <p>We reserve the right to update these Terms at any time. Your continued use of our Website indicates acceptance of any changes.</p>
                        <h3>3. Scope of Services</h3>
                        <p>The specific scope, deliverables, technologies, timelines, and pricing for each project are defined in the approved SOW / proposal.
                            Only written agreements are binding — verbal commitments are not considered final.
                            Any features or requirements not included in the approved scope will be treated as a Change Request and may incur additional charges.</p>
                        <h3>4. Client Responsibilities</h3>
                        <p>The client agrees to:</p>
                        <ul>
                            <li>Provide timely access to project-related information, content, credentials, and approvals</li>
                            <li>Ensure they have legal rights or licenses for any third-party content, images, code, or materials provided</li>
                            <li>Back up any existing data before development or deployment</li>
                            <li>Respond to queries, clarifications, and review requests within reasonable time</li>
                        </ul>
                        <p>Delays in providing information, approvals, or content may extend project timelines.</p>
                        <h3>5. Payment Terms</h3>
                        <br />
                        <h6>5.1 Milestone-Based Payments</h6>
                        <p>Payments are structured based on milestones mentioned in the SOW. Work begins only after the initial payment.</p>
                        <br />
                        <h6>5.2 Late or Non-Payment</h6>
                        <p>If a client fails to make timely payments:</p>
                        <ul>
                            <li>Work may be paused or withheld</li>
                            <li>Deliverables, source code, or hosting access may be suspended</li>
                            <li>A late fee of 2% per month may be applied</li>
                            <li>Legal action may be taken for recovery of dues</li>
                        </ul>
                        <br />
                        <h6>5.3 Cancellation & Refunds</h6>
                        <ul>
                            <li>If a project is cancelled by the client, a cancellation fee will apply depending on the work completed.</li>
                            <li>Since our services are custom-built, completed milestones are non-refundable.</li>
                        </ul>
                        <br />
                        <h6>5.4 Ownership</h6>
                        <p>Full ownership of code, designs, and deliverables transfers to the client only after <b>full payment.</b>
                            <br />
                            <br />
                            Accepted Payment Methods:<b> Bank Transfer</b>, <b>UPI</b>, <b>PayPal</b>.
                        </p>
                        <h3>6. Project Delivery, Review & Acceptance</h3>
                        <h6>6.1 Delivery</h6>
                        <p>Upon completion of milestones, deliverables will be shared for review.</p>
                        <br />
                        <h6>6.2 Review Window</h6>
                        <p>Clients must review the submitted work within <b>7 days</b>.<br />
                            If no response is received within this period, the deliverables are considered <b>accepted by default</b>.</p>
                        <br />
                        <h6>6.3 Post-Delivery Responsibilities</h6>
                        <p>Unless a maintenance agreement exists:</p>
                        <ul>
                            <li>We are not responsible for future updates, server issues, security breaches, data loss, or third-party changes.</li>
                            <li>Ongoing support/maintenance is chargeable.</li>
                        </ul>
                        <h3>7. Support & Warranty</h3>
                        <p>Girips Technologies provides:</p>
                        <ul>
                            <li><b>30 days of free support </b>after final delivery <br />
                                (Covers: bug fixes, performance issues, minor corrections)
                            </li>
                        </ul>
                        <p>Does NOT cover:</p>
                        <ul>
                            <li>New features or redesigns</li>
                            <li>Issues caused by third-party plugins, hosting changes, or client modifications</li>
                            <li>Content updates or enhancements</li>
                        </ul>
                        <p>After 30 days, support is hourly or retainer-based.</p>
                        <h3>8. Intellectual Property Rights</h3>
                        <h6>8.1 Girips Technologies IP</h6>
                        <p>Our reusable libraries, components, internal tools, frameworks, and methodologies remain our intellectual property.</p>
                        <br />
                        <h6>8.2 Client IP</h6>
                        <p>Final project deliverables become the client's property after full payment.</p>
                        <br />
                        <h6>8.3 Portfolio Rights</h6>
                        <p>We may showcase completed projects on our portfolio or marketing materials <b>unless the client objects in writing</b>.</p>
                        <h3>9. Third-Party Services & Integrations</h3>
                        <p>Our Services may involve third-party APIs, hosting providers, plugins, or tools.<br />
                            We are not responsible for:</p>
                        <br />
                        <ul>
                            <li>Downtime, failure, or performance issues of third-party services</li>
                            <li>Licensing or subscription fees for third-party tools</li>
                            <li>Data loss caused by third-party updates or policy changes</li>
                        </ul>
                        <p>Clients are encouraged to review third-party terms before use.</p>
                        <h3>10. Confidentiality</h3>
                        <p>Both parties agree to keep all business information, access details, project files, documents, and proprietary data confidential.<br />
                            Confidentiality obligations survive termination of the project.
                        </p>
                        <h3>11. Indemnification</h3>
                        <p>Clients agree to indemnify and hold Girips Technologies harmless for:</p>
                        <br />
                        <ul>
                            <li>Copyright violations from client-provided materials</li>
                            <li>Illegal use of our Services</li>
                            <li>Losses resulting from misuse of deliverables or third-party content</li>
                        </ul>
                        <p>Girips Technologies will indemnify the client for damages caused by proven negligence or intentional misconduct on our part.</p>
                        <h3>12. Limitation of Liability</h3>
                        <p>To the maximum extent permitted by law:</p>
                        <br />
                        <ul>
                            <li>We are not liable for indirect, incidental, special, or consequential damages.</li>
                            <li>Our total liability shall not exceed the total amount paid by the client for the specific project.</li>
                            <li>We make no guarantee that the Website or Services will be error-free, uninterrupted, or 100% secure.</li>
                        </ul>
                        <h3>13. Website Usage Rules</h3>
                        <p>By using our Website, you agree not to:</p>
                        <br />
                        <ul>
                            <li>Attempt to hack, extract data, or disrupt Website functionality</li>
                            <li>Upload harmful or malicious content</li>
                            <li>Submit false information</li>
                        </ul>
                        <p>We may block IPs, suspend access, or pursue legal action for misuse.</p>
                        <h3>14. Termination</h3>
                        <p>We may terminate or suspend Services immediately if you:</p>
                        <br />
                        <ul>
                            <li>Breach these Terms</li>
                            <li>Fail to make payments</li>
                            <li>Engage in fraudulent or harmful activity</li>
                        </ul>
                        <p>Upon termination:</p>
                        <br />
                        <ul>
                            <li>All pending payments become immediately due</li>
                            <li>Confidentiality and IP clauses remain in effect</li>
                        </ul>
                        <h3>15. Force Majeure</h3>
                        <p>Girips Technologies is not liable for delays caused by events outside our control, including:</p>
                        <br />
                        <ul>
                            <li>Natural disasters</li>
                            <li>Internet/hosting outages</li>
                            <li>Third-party failures</li>
                            <li>Political events</li>
                            <li>Pandemics</li>
                            <li>War, strikes, or government restrictions</li>
                        </ul>
                        <p>Project timelines will be extended accordingly.</p>
                        <h3>16. Governing Law & Dispute Resolution</h3>
                        <p>These Terms are governed by the laws of India.</p>
                        <p>In case of disputes:</p>
                        <br />
                        <ul>
                            <li>Both parties will first attempt to resolve the matter through mutual discussion</li>
                            <li>If unresolved, disputes will fall under the <b>exclusive jurisdiction of courts in Jaipur, Rajasthan, India</b></li>
                        </ul>
                        <h3>17. Amendments</h3>
                        <p>We may update or modify these Terms anytime without prior notice.
                            The updated Terms will be posted on this page.</p>
                        <h3>18. Contact Information</h3>
                        <p>A7 Virat Nagar, Goner Road, Jaipur, Rajasthan – 302031, India<br /> Call Us:<a href="tel:+91 73574 94050" target={'_blank'} style={{ color: 'rgba(52, 152, 219, 1)' }}> +91 73574 94050</a><br />Email Us: <a href="mailto:info@giripstechnologies.com" target={'_blank'} style={{ color: 'rgba(52, 152, 219, 1)' }}>info@giripstechnologies.com</a></p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TermsConditions